import React from "react";
import {Card, SimpleCardHeading} from "peggirkit";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {FormattedMessage} from "react-intl";
import {PlacedOrderOverview} from "@/data/entities/order";
import ProductList from "@widgets/pos/orders/details/order/overview/summary/products/ProductList";
import PricingTotals from "@widgets/pos/orders/details/order/overview/summary/totals/PricingTotals";

type Props = {
    order: PlacedOrderOverview,
};

const OrderSummaryCard = ({order}: Props) => {
    return (
        <Card
            containerClassname={"col-span-3"}
            header={
                <CardHeader>
                    <SimpleCardHeading title={<FormattedMessage id={"order"}/>}/>
                </CardHeader>
            }
        >
            <div className={"w-full grid grid-cols-5 gap-14 items-start"}>
                <ProductList order={order}/>
                <PricingTotals order={order}/>
            </div>
        </Card>
    );
};

export default OrderSummaryCard;